/**
 * Performance budgets — the single source (architecture §10): art-direction §3.5 (Medium tier, mid phone) and
 * creatures-animation §B10 transcribed once. Owner: Engine (F2). Pure data.
 */

/** art §3.5 (Medium tier, 2022 mid-range Android / iPhone 13). */
export const ART_BUDGET = {
  gpuFrameMs: 9, gpuFolioMapMs: 3, cpuFrameMs: 6, fullScreenPasses: 2,
  drawCalls: { med: 40, high: 60, hardCap: 48, otherScreens: 25 },
  triangles: { arenaTypical: 18_000, arenaHardCap: 20_000, map: 30_000, dungeonFight: 20_000, cardTable: 8_000, creatureDressed: 2_230, creatureBody: 1_470 },
  aluPerPixel: { creature: 180, sky: 45, composite: 90 },
  compositeFetches: { med: 6, high: 14 },
  networkTexturesOn3d: 0,
  coldStartMB: 3, bootArtKB: 400, routeAboveFoldKB: 600, routeTotalMB: 1.5,
  paintedArtGpuMB: 32, textureMB: 64,
  faceCam: { ms: 900, gpuMs: 0.4 },
  triptychMs: 1500,
} as const;

/** creatures §B10 (desktop, mid phone), ms. */
export const ANIM_BUDGET = {
  fullBuild: [6, 15], partRebuild: [1, 2], heroLodBuild: [1.5, 4], evalPerMain: [0.15, 0.4], secondaryPerMain: [0.05, 0.15],
  battleTotal: [0.7, 2.0], bossSquid: [0.2, 0.55], v3Additions: [0.03, 0.08], tableBusts: [0.02, 0.05],
  battleFrameGate: { p99Ms: 20, maxMs: 33, allocations: 0 },
} as const;

/** architecture §10 rows the engine reports against. */
export const ENGINE_BUDGET = {
  frameMs: 16.7, cpuAvgMs: 6, cpuP95Ms: 8, encodeMs: 3, cineMs: 0.1, pipelineCompileMs: 400, heapMB: 150,
  uploadTypicalKB: 30, uploadWorstKB: 80, maxPipelines: 16, idleGpuFramesOver2s: 0,
} as const;

/** art §3.4 particle / decal caps per tier. */
export const PARTICLE_CAPS = { low: [300, 16], med: [800, 32], high: [1500, 48], ultra: [2500, 64] } as const;
